// 客户模块-菜单 L3
const config = {
    'customer': { // 盖章人/业务实体维护-页面 L4
        'bigData-btn-detailPageStamperTabUse': '客户模块,客户-客户详情,签章人,启用', // 启用-按钮 L6
        'bigData-btn-detailPageStamperTabStop': '客户模块,客户-客户详情,签章人,停用', // 停用-按钮 L6
        'bigData-btn-detailPageStamperTabSync': '客户模块,客户-客户详情,签章人,同步', // 同步-按钮 L6
        'bigData-btn-detailPageStamperTabLink': '客户模块,客户-客户详情,签章人,前往授权', // 前往授权-按钮 L6
        'bigData-page-detailPageStamperTabLink': '客户模块,客户-客户详情,签章人,前往授权', // 前往授权-按钮 L6
        'bigData-page-detailPageEbcaTab': '客户模块,盖章人/业务实体维护,业务实体,', // 业务实体 L5
        'bigData-page-detailPageStamperTab': '客户模块,盖章人/业务实体维护,盖章人,', // 盖章人 L5
        'bigData-btn-customer-stamper-mobile': '客户模块,盖章人/业务实体维护,盖章人,盖章人手机加密切换', // 业务实体 L5
        'bigData-btn-customer-stamper-email': '客户模块,盖章人/业务实体维护,盖章人,盖章人邮箱加密切换', // 业务实体 L5
        'bigData-btn-customer-stamper-id-number': '客户模块,盖章人/业务实体维护,盖章人,号码身份证加密切换' // 业务实体 L5
    },
    'customerManage': { // 客户管理-页面 L4
        'bigData-btn-customer-list-search': '客户模块,客户管理-客户列表,,搜索', // 搜索-按钮 L6
        'bigData-btn-customer-list-export': '客户模块,客户管理-客户列表,,导出', // 导出-按钮 L6
        'bigData-page-customer-detail': '客户模块,客户管理-客户详情', // 客户详情 L5
        'bigData-btn-customer-detail-save': '客户模块,客户管理-客户详情,,保存', // 保存-按钮 L6
        'bigData-btn-customer-detail-flow': '客户模块,客户管理-客户详情,,提交审批', // 提交审批-按钮 L6
        'bigData-btn-customer-detail-infoChange': '客户模块,客户管理-客户详情,,信息变更', // 信息变更-按钮 L6
        'bigData-btn-customer-detail-statusChange': '客户模块,客户管理-客户详情,,状态变更', // 状态变更-按钮 L6
        'bigData-btn-customer-detail-insertSup': '客户模块,客户管理-客户详情,,生成供应商', // 生成供应商-按钮 L6
        'bigData-btn-customer-detail-insertVir': '客户模块,客户管理-客户详情,,新建虚拟客户', // 新建虚拟客户-按钮 L6
        'bigData-btn-customer-detail-asynGroup': '客户模块,客户管理-客户详情,,同步集团', // 同步集团-按钮 L6
        'bigData-btn-customer-detail-asyncLaw': '客户模块,客户管理-客户详情,,同步法务', // 同步法务-按钮 L6
        'bigData-btn-customer-detail-xsyLink': '客户模块,客户管理-客户详情,,跳转销售易', // 跳转销售易-按钮 L6
        'bigData-btn-customer-detail-updateBussiness': '客户模块,客户管理-客户详情,,更新工商信息', // 更新工商信息-按钮 L6
        'bigData-btn-customer-detail-getRiskLevel': '客户模块,客户管理-客户详情,,获取风险等级', // 获取风险等级-按钮 L6
        'bigData-btn-customer-detail-opsUnlock': '客户模块,客户管理-客户详情,,运维解锁', // 运维解锁-按钮 L6
        'bigData-btn-customer-detail-xiaoshouyiPush': '客户模块,客户管理-客户详情,,销售易重推', // 销售易重推-按钮 L6
        'bigData-btn-customer-detail-refresh': '客户模块,客户管理-客户详情,,刷新', // 刷新-按钮 L6
        'bigData-page-customer-flow-customerApplyFlow': '客户模块,客户管理-客户新增提交流程', // 客户新增提交流程 L5
        'bigData-page-customer-flow-customerChangeFlow': '客户模块,客户管理-客户变更流程', // 客户变更流程 L5
        'bigData-btn-customer-detail-mobile': '客户模块,客户管理-客户详情,联系人,手机加密切换', // 启用-按钮 L6
        'bigData-btn-customer-detail-tel': '客户模块,客户管理-客户详情,联系人,电话加密切换', // 启用-按钮 L6
        'bigData-btn-customer-detail-contactAddress': '客户模块,客户管理-客户详情,联系人,联系地址加密切换', // 启用-按钮 L6
        'bigData-btn-customer-detail-fax': '客户模块,客户管理-客户详情,联系人,传真加密切换', // 启用-按钮 L6
        'bigData-btn-customer-detail-email': '客户模块,客户管理-客户详情,联系人,邮箱加密切换', // 启用-按钮 L6
        'bigData-btn-customer-detail-erp': '客户模块,客户管理-客户详情,,特权维护' // 销售易重推-按钮 L6
    }
};

export default config;
